import * as LocalStore from 'localforage';

// eslint-disable-next-line import/no-default-export
export default {
    getItem: LocalStore.getItem,
    setItem: LocalStore.setItem,
    deleteItem: LocalStore.removeItem
};
